export default __webpack_public_path__ + "static/media/me2.32642438.svg";